import type {
  GetBackListeElettoraliIdMembriParams,
  MembroListaElettorale,
} from '@framework/api-client';

/**
 * Limite alto applicato alle query del widget di scelta lista (liste e candidati):
 * le entità in gioco sono poche, quindi alziamo il limite oltre la dimensione
 * pagina di default per evitare la paginazione e non troncare i risultati.
 */
export const electoralListChooserFetchLimit = 200;

/**
 * Query condivisa per i candidati di una lista mostrati nel widget di scelta
 * lista. Definita in un unico punto così che ogni box lista usi la stessa entry
 * di cache react-query. Filtriamo i soli candidati eleggibili (gli altri membri
 * non sono votabili) e li ordiniamo per ordine, cognome e nome (#57760).
 */
export const electoralListChooserMembersParams: GetBackListeElettoraliIdMembriParams =
  {
    isEleggibile: true,
    isCandidato: true,
    limite: electoralListChooserFetchLimit,
    ordinamenti: ['ordine', 'cognome', 'nome'],
  };

/** Opzioni di richiesta per serializzare correttamente l'array `ordinamenti`. */
export const electoralListChooserMembersRequestOptions = {
  request: { arrayFormat: 'repeat' as const },
};

/**
 * Primo candidato della lista per `ordine` crescente (i valori nulli vanno in
 * coda). Usato per assegnare il candidato di default quando il votante seleziona
 * una lista senza esprimere una preferenza.
 */
export function firstMemberByOrdine(
  members: MembroListaElettorale[],
): MembroListaElettorale | undefined {
  return members.reduce<MembroListaElettorale | undefined>(
    (best, m) =>
      !best || (m.ordine ?? Infinity) < (best.ordine ?? Infinity) ? m : best,
    undefined,
  );
}
